import { TypeChecker } from '@attain-apps/type-guards'

/**
 * The normalized key used to match calculated BCH data back to PMS Upload rows.
 */
export type Identifier = string
export namespace Identifier {
  export const isIdentifier: TypeChecker<Identifier> = TypeChecker.isString

  /**
   * Normalizes a BCH document/payment value into a lookup key.
   */
  export function from(value: string | undefined): Identifier | undefined {
    const normalized = value?.replace(/\s+/g, ' ').trim().toUpperCase()
    if (!normalized) {
      return undefined
    }
    return normalized
  }
}
